"use client";

import React from "react";
import { SnackbarProvider } from "notistack";
import PropTypes from "prop-types";
import { Notification } from "@/components/notification/notification";

export function NotificationBus({ children }) {
  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      Components={{
        default: Notification,
        success: Notification,
        error: Notification,
        warning: Notification,
        info: Notification,
      }}
    >
      {children}
    </SnackbarProvider>
  );
}

NotificationBus.propTypes = {
  children: PropTypes.node.isRequired,
};
